import { Base64 } from "js-base64";
import { FC } from "react";

import { Stack, Typography } from "@mui/material";
import TextField from "@mui/material/TextField";

import {
  likelyBase64EncodedPEMBlock,
  likelyPemEncodedCertificate,
} from "../../../../../validators/certs";
import CodeSnippet from "@/components/CodeSnippet";

interface AddCaCertProps {
  cert: string;
  setCert: (value: ((prevState: string) => string) | string) => void;
}

export const AddCaCert: FC<AddCaCertProps> = ({
  cert,
  setCert,
}: AddCaCertProps) => {
  return (
    <Stack direction="column" spacing={2}>
      <Typography>
        Use the command below to obtain your cluster's CA certificate, then
        paste it below:
      </Typography>
      <CodeSnippet
        code={`kubectl get configmap kube-root-ca.crt -o=jsonpath='{.data.ca\\.crt}'`}
        copyInfo="kubectl_command"
      />
      <Stack direction="row" spacing={2} alignItems={"flex-start"}>
        <TextField
          multiline
          minRows={5}
          maxRows={20}
          placeholder={"-----BEGIN CERTIFICATE-----\n..."}
          value={cert}
          inputProps={{
            overflow: "hidden",
            resize: "none",
            spellCheck: "false",
            style: {
              fontFamily: "monospace",
              lineHeight: "24px",
              minWidth: "64ch",
              maxWidth: "64ch",
              scrollbarWidth: "none",
            },
          }}
          onChange={(e) => {
            let v = e.target.value.trim();
            if (likelyBase64EncodedPEMBlock(v)) {
              const decoded = Base64.decode(v);
              v = decoded.trim();
            }
            setCert(v);
          }}
          error={cert.length > 0 && !likelyPemEncodedCertificate(cert)}
          helperText={
            cert.length > 0 &&
            !likelyPemEncodedCertificate(cert) &&
            "Certificate is malformed"
          }
        />
      </Stack>
    </Stack>
  );
};
